import { CogMenu } from "@web/search/cog_menu/cog_menu";

export class FormCogMenu extends CogMenu {
    static template = "web.FormCogMenu";
}
